import React, { useEffect, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.scss"
import "./styles.scss"

const ProjectsFilters = ({ filters, filterCallback, isDesktop }) => {
  const [primaryFilterActive, setPrimaryFilterActive] = useState("all work")
  const [secondaryFiltersActive, setSecondaryFiltersActive] = useState([])
  const [wrapperHeight, setWrapperHeight] = useState(null)

  const [isLoaded, setIsLoaded] = useState(false)
  const [filtersObj, setFiltersObj] = useState({
    industries: [],
    scope: [],
    services: [],
  })
  const primaryFilters = ["all work", "industries", "services", "scope"]

  useEffect(() => {
    filterCallback(primaryFilterActive, secondaryFiltersActive)
  }, [secondaryFiltersActive])

  useEffect(() => {
    setIsLoaded(true)
    setTimeout(() => {
      setWrapperHeight(49)
    }, 1)
  }, [])

  function activeFilters(primary, secondary) {
    if (isDesktop) {
      if (primary === "all work") {
        setTimeout(() => {
          setWrapperHeight(49)
        }, 0)
      } else {
        setTimeout(() => {
          const filtersHeight = document.querySelector(
            ".section--filters .filters--secondary"
          ).clientHeight
          setWrapperHeight(filtersHeight + 49)
        }, 0)
      }
    }

    setPrimaryFilterActive(primary)
    setSecondaryFiltersActive(secondary)
    setFiltersObj({
      industries: [],
      scope: [],
      services: [],
    })
  }

  function setSecondaryFiltersArr(name) {
    if (name.length === 0) {
      setSecondaryFiltersActive([])
    } else {
      const elementIndex = secondaryFiltersActive.indexOf(name)
      if (elementIndex !== -1 && secondaryFiltersActive.length > 0) {
        let arr = [...secondaryFiltersActive]
        arr.splice(elementIndex, 1)
        setSecondaryFiltersActive(arr)
      } else {
        setSecondaryFiltersActive([...secondaryFiltersActive, name])
      }
    }
  }

  function handleChange(event) {
    const values = [...event.target.options]
      .filter(o => o.selected)
      .map(o => o.value)
    setSecondaryFiltersActive(values)
  }

  return (
    <section className="section section--filters">
      {!isDesktop && (
        <>
          <div className={`wrapper--text  wrapper--text-overflow`}>
            <Swiper
              slidesPerView="auto"
              slidesOffsetBefore={24}
              slidesOffsetAfter={24}
            >
              {primaryFilters.map((filter, i) => {
                return (
                  <SwiperSlide key={i}>
                    <div
                      onClick={() => {
                        activeFilters(filter, [])
                      }}
                      className={`filter ${
                        primaryFilterActive === filter ? "active" : ""
                      }`}
                    >
                      {filter.charAt(0).toUpperCase() + filter.slice(1)}
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
          <div className="wrapper--text">
            {primaryFilterActive !== "all work" && (
              <div className="filters-mobile--secondary">
                <span>Showing</span>
                <div className="select">
                  <div>
                    {secondaryFiltersActive.length === 0 && <span>All</span>}
                    <span>
                      {secondaryFiltersActive.length > 0 &&
                        secondaryFiltersActive.map((filter, i) => {
                          return (
                            <React.Fragment key={i}>
                              {filter}
                              {`${
                                i + 1 < secondaryFiltersActive.length
                                  ? ", "
                                  : ""
                              }`}
                            </React.Fragment>
                          )
                        })}
                    </span>
                  </div>
                  <select
                    multiple
                    value={secondaryFiltersActive}
                    onChange={e => {
                      handleChange(e)
                    }}
                  >
                    {filters[primaryFilterActive].map((filter, i) => {
                      return (
                        <option
                          key={i}
                          className={`filter-mobile ${
                            filtersObj[primaryFilterActive].indexOf(filter) !==
                            -1
                              ? "active"
                              : ""
                          }`}
                          value={filter}
                        >
                          {filter}
                        </option>
                      )
                    })}
                  </select>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {isDesktop && (
        <div className="wrapper--text" style={{ height: `${wrapperHeight}px` }}>
          <ul className="filters--primary">
            {primaryFilters.map((filter, i) => {
              return (
                <li
                  onClick={() => {
                    activeFilters(filter, [])
                  }}
                  key={i}
                  className={`filter ${
                    primaryFilterActive === filter ? "active" : ""
                  }`}
                >
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </li>
              )
            })}
          </ul>
          {primaryFilterActive !== "all work" && (
            <ul className="filters--secondary">
              <li
                onClick={() => setSecondaryFiltersArr([])}
                className={`filter ${
                  secondaryFiltersActive.length === 0 ? "active" : ""
                }`}
              >
                All
              </li>
              {primaryFilterActive !== "all work" &&
                filters[primaryFilterActive].map((filter, i) => {
                  return (
                    <li
                      style={{
                        animationDelay: `${(i / 1) * 0.1}s`,
                      }}
                      key={filter}
                      className={`filter ${
                        secondaryFiltersActive.indexOf(filter) !== -1
                          ? "active"
                          : ""
                      }`}
                      onClick={() => setSecondaryFiltersArr(filter)}
                    >
                      {filter}
                    </li>
                  )
                })}
            </ul>
          )}
        </div>
      )}
    </section>
  )
}

export default ProjectsFilters
